<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">监控设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="设备名称"
        prop="DeviceName"
        style="display: inline-block"
      >
        <el-input
          v-model="ruleForm.DeviceName"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请输入设备名称，限10个字"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="设备编号"
        prop="DeviceNo"
        style="display: inline-block"
      >
        <el-input
          v-model="JsonExtend.DeviceNo"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
          placeholder="请输入设备编号"
        ></el-input>
      </el-form-item>

      <el-form-item label="IP地址" prop="Ip" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Ip"
          v-bind:disabled="!IsEdit"
          placeholder="请输入IP地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="端口" prop="Port" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Port"
          v-bind:disabled="!IsEdit"
          placeholder="请输入端口"
        ></el-input>
      </el-form-item>
      
      <el-form-item label="区域" prop="RegionId" style="display: inline-block">
        <el-select
          v-model="ruleForm.RegionId"
          placeholder="请选择"
          style="width: 50rem"
          v-bind:disabled="!IsEdit"
        >
          <el-option
            v-for="item in RegionData"
            :key="item.RegionId"
            :label="item.RegionName"
            :value="item.RegionId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="安装位置" prop="Port" style="display: inline-block">
        <el-input
          style="width: 50rem"
          v-model="JsonExtend.Port"
          v-bind:disabled="!IsEdit"
          placeholder="请输入安装位置"
        ></el-input>
      </el-form-item>

      <el-form-item label="经纬度" prop="Latitude" style="display: inline-block">
        <el-input
          style="width: 45rem"
          v-model="ruleForm.Latitude"
          v-bind:disabled="!IsEdit"
          placeholder="请选择经纬度"
        ></el-input>
        <!-- <el-button
          @click="getCurrentPostion()"
          style="width:8rem;"
          v-bind:disabled="!IsEdit"
          >定位</el-button
        >-->
        <ZjLngLatSelect
          :point_lat="ruleForm.Latitude"
          :point_lng="ruleForm.Longitude"
          style="margin-left: 0.5rem"
          @onGotLngLat="onGotLngLat"
        ></ZjLngLatSelect>
      </el-form-item>

      <el-form-item label="描述" prop="Port" style="display: inline-block">
        <el-input
          style="width: 113rem"
          v-model="JsonExtend.Port"
          v-bind:disabled="!IsEdit"
          type="textarea"
          rows="5"
        ></el-input>
      </el-form-item>

      <el-form-item class="left">
        <el-button @click="onBack()">取消</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :disabled="!IsEdit"
          v-if="IsEdit"
          >保存</el-button
        >
        <!--      <el-button @click="resetForm('')" :disabled="!IsEdit" v-if="IsEdit">重置</el-button> -->
      </el-form-item>
    </el-form>
    <remote-script
      src="//api.map.baidu.com/api?v=3.0&ak=ERZS9uzwv1zEBuSEAxN5DM5qjZBVHIfq"
    ></remote-script>
  </div>
</template>
<script>
import MyApis from "../../apis";
import ZJApp from "../../../../app";
import waitAll from "../../../../../utils/src/waitAll";

export default {
  name: "monitorInfo",
  controller: "UI",
  action: "monitorInfo",
  data() {
    return {
      ruleForm: {
        DeviceId: null,
        DeviceName: "",
        DeviceType: "", //设备类型
        IsOnline: false, //是否在线
        RegionId: null, //区域ID
        RegionName: null, //区域名称
        Latitude: null,
        Longitude: null,
        EquipmentType: "Monitor",
      },
      rules: {
        DeviceName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        DeviceType: [
          { required: true, message: "请选择设备类型", trigger: "change" },
        ],
        // RegionId: [{ required: true, message: "请选择区域", trigger: "change" }]
      },
      JsonExtend: {
        DeviceNo: null, //设备编号
        NearBy: null, //附近设备
        Ip: null,
        Port: null, //端口号
        Channel: null, //通道号
        UserName: null,
        Password: null,
        StartNumber: null, //rtsp
        DensityAlarmThreshold: null, //密度间值
      },
      IsEdit: false,
      DeviceTypesArr: [],
      RegionData: [],
    };
  },
  created: function () {
    if (this.$route.query.DeviceId) {
      this.search();
    }
    if (this.$route.query.type == "look") {
      this.IsEdit = false;
    } else {
      this.IsEdit = true;
    }
    // 设备类型
    this.getType();
    this.basedataRegion(); //区域列表
  },
  mounted: function () {},
  watch: {
    $route: function () {
      if (this.$route.query.DeviceId) {
        this.search();
      }
    },
  },
  methods: {
    getType() {
      this.config
        .getUValue(":Monitor.DeviceTypes", "")
        .then((d) => {
          //console.log(d)
          let MonitorList = [];
          d.JValue.forEach((p) => {
            if (p.ItemKey != "SubSystem.Monitor.EquipmentType.Sos") {
              MonitorList.push(p);
            }
          });
          this.DeviceTypesArr = MonitorList;
        })
        .catch((e) => console.error(e));
    },
    basedataRegion() {
      let searchInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionApi()
        .GetRegionInfos(searchInfo)
        .then((r) => {
          // console.log("区域")
          // console.log(r)
          this.RegionData = r.data.Data;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let DeviceId = this.$route.query.DeviceId;
      let that = this;
      if (DeviceId) {
        let searchInfo = { DeviceId: DeviceId };
        new MyApis.MonitorApi()
          .GetEquipmentById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            // console.log(r);
            that.ruleForm = r;
            if (r.JsonExtend) {
              that.JsonExtend = JSON.parse(r.JsonExtend);
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    onGotLngLat(obj) {
      this.ruleForm.Latitude = obj.lat;
      this.ruleForm.Longitude = obj.lng;
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    save() {
      this.saveData();
    },
    saveData() {
      this.RegionData.forEach((item) => {
        if (item.RegionId == this.ruleForm.RegionId) {
          this.ruleForm.RegionName = item.RegionName;
        }
      });
      if (this.ruleForm.Longitude != null) {
        this.ruleForm.Longitude = Number(this.ruleForm.Longitude);
      }
      if (this.ruleForm.Latitude != null) {
        this.ruleForm.Latitude = Number(this.ruleForm.Latitude);
      }
      this.ruleForm.JsonExtend = JSON.stringify(this.JsonExtend);
      if (this.$route.query.type == "edit") {
        //编辑
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.ruleForm);
        new MyApis.MonitorApi()
          .UpdateEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "监控设备修改";
            this.logInfo.LogMessage = "监控设备修改";
            this.logInfo.ModuleName = "视频监控";
            this.logInfo.PageName = "监控设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        // 增加
        let formObj = {
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          Validity: 1, //新增编辑是1，删除是0
        };
        let formAll = Object.assign(formObj, this.ruleForm);
        new MyApis.MonitorApi()
          .AddEquipment(formAll)
          .then((r) => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！",
            });
            this.logInfo.ActionName = "监控设备添加";
            this.logInfo.LogMessage = "监控设备添加";
            this.logInfo.ModuleName = "视频监控";
            this.logInfo.PageName = "监控设备管理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = this.imgList;
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item,
            data: {
              module: "unifiedRelease", //模块名
              submodule: "Announcement", //子模块
              assocID: feedid, //业务ID
              uploader: ZJApp.ZJUser.current.UserName, //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    getCurrentPostion() {
      let that = this;
      // eslint-disable-next-line no-undef
      var geolocation = new BMap.Geolocation();
      // eslint-disable-next-line no-undef
      // 开启SDK辅助定位
      geolocation.enableSDKLocation();
      geolocation.getCurrentPosition(function (r) {
        console.log(r);
        // eslint-disable-next-line no-undef
        if (r) {
          that.ruleForm.Latitude = r.latitude;
          that.ruleForm.Longitude = r.longitude;
        } else {
          // Toast("获取地理位置失败" + this.getStatus());
        }
      });
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
};
</script>
<style type="text/css"></style>
